import { fetchAdminTokens } from '../services/tokenApi.js';

export const createTokenSlice = (set) => ({
  tokens: {
    pending: [],
    completed: [],
    loading: false,
    error: null
  },

  loadTokens: async () => {
    set((currentState) => ({
      tokens: {
        ...currentState.tokens,
        loading: true,
        error: null
      }
    }));

    try {
      const tokenResponse = await fetchAdminTokens();
      const pendingTokens = tokenResponse.pending || [];
      const completedTokens = tokenResponse.completed || [];

      set({
        tokens: {
          pending: pendingTokens,
          completed: completedTokens,
          loading: false,
          error: null
        }
      });
    } catch (error) {
      set((currentState) => ({
        tokens: {
          ...currentState.tokens,
          loading: false,
          error: error.message || 'Unable to load token data'
        }
      }));
    }
  },

  getTokensByBranch: (branchId) => (state) => {
    if (!branchId || branchId === 'all') {
      return {
        pending: state.tokens.pending || [],
        completed: state.tokens.completed || []
      };
    }
    return {
      pending: (state.tokens.pending || []).filter((token) => token.branchId === branchId),
      completed: (state.tokens.completed || []).filter((token) => token.branchId === branchId)
    };
  }
});